<div class="e-back-to-results-bar">
    <div class="e-layout-limiter">
        <button class="e-back-button" (click)="backToResults()">
            <i class="fas fa-arrow-left"></i>
            Back
        </button>
    </div>
</div>

<div class="e-sku-capsule-layout" role="main">
    <!-- TODO: Hidden for MVP release
    <button class="e-download-button" aria-label="Download SKU Capsule" matTooltipClass="e-mat-tooltip"
        matTooltipPosition="below" matTooltip="Download SKU Capsule" matTooltipShowDelay="500">
        <i class="far fa-download"></i>
    </button>
    -->

    <div class="e-date-range-container e-date-range-inline" role="region"
        aria-label="Select a date range and period for the SKU data">
        <div class="e-date-range-selector">
            <span>Date range:</span>
            <via-date-range *ngIf="showDateRange" (onDateRangeChange)="updateDateRange($event)"
                [datePickerSettings]="dateSettings"></via-date-range>
        </div>
        <!-- TODO: Hidden for MVP release
        <via-period-range *ngIf="showFrequency"></via-period-range>
        -->
    </div>

    <mat-tab-group animationDuration="0ms" role="tabpanel">
        <mat-tab label="Summary">
            <via-sku-summary [sku]="selectedSku" [dateRange]="selectedDateRange"></via-sku-summary>
        </mat-tab>
        <!-- TODO: Phase 2
        <mat-tab label="SKU Data">
            <via-sku-data></via-sku-data>
        </mat-tab>
        <mat-tab label="SKU Feedback">
            <via-sku-feedback></via-sku-feedback>
        </mat-tab>
        -->
    </mat-tab-group>
</div>